module.exports = __webpack_public_path__ + "11639af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-pet-shuttle-service.png
// module id = 1536
// module chunks = 0